import React, { Component } from 'react'

import { throttle } from 'lodash';

import { getViewportSize } from '../../utils/screen'
import { getDistanceFromTop, getElemPosition, getElemHeight } from '../../utils/position.js'


import './Parallax.css'



class Parallax extends Component {


    constructor(props) {

        super(props)

        this.state = {

            percentProgress: 0,
            percentValue: 0
        }

        this.scroll = this.scroll.bind(this);
        this.bind = this.bind.bind(this);
        this.removeBind = this.removeBind.bind(this);

    }

    scroll(e) {


        let start = this.props.start
        let finish = this.props.finish
        let isReversed = this.props.isReversed


        let scrolled = getDistanceFromTop()
        let viewport = getViewportSize()

        let parent = getElemPosition(this.parent)
        let parentHeight = getElemHeight(this.parent)

        let progress = scrolled + (viewport.height / 2)


        // console.log(`scrolled: ${scrolled}`)
        // console.log(`Viewport: ${viewport.width}x${viewport.height}`)
        // console.log(`parent top: ${parent.top}`)
        // console.log(`parent height: ${parentHeight}`)

        // let inViewport = (progress >= parent.top) ? true : false

        // let middle = parent.top + (parentHeight / 2) + (viewport.width / 2)

        let overlap = progress - parent.top



        let percentProgress = Math.round(overlap / parentHeight * 100)


        let percentProgressReversed = 100 - Math.round(overlap / parentHeight * 100)


        let percentValue = Math.round((percentProgress / 100) * finish)

        if (isReversed) {
            percentValue = Math.round((percentProgressReversed / 100) * finish)
        }

        // console.log(`overlap: ${percentProgress}`)
        // console.log(`percent: ${percentValue}%`)



        if (percentProgress < 0) {
            if (isReversed) {
                percentValue = finish
            }
            else {
                percentValue = start
            }
        }

        if (percentProgress > 100) {
            if (isReversed) {
                percentValue = start
            }
            else {
                percentValue = finish
            }
        }

        this.setState({
            percentProgress: percentProgress,
            percentValue: percentValue
        })


        // console.log(`progress: ${progress}`)
        // console.log(`middle: ${middle}`)

        // this.setState({
        //     inViewport
        // });

    }



    componentDidMount() {

        this.cb = throttle(this.scroll)

        this.bind();

    }

    componentWillUnmount() {
        this.removeBind();
    }


    bind() {
        window.addEventListener('scroll', this.cb);
    }

    removeBind() {

        window.removeEventListener('scroll', this.cb);
    }

    render() {

        const { percentValue } = this.state

        const targetStyle = {
            // transform: `translateY(${progress}%)`
            top: `${percentValue}%`
        }

        return (

            <div className="parallax" ref={(parent) => { this.parent = parent }}>

                {this.props.content}

                <div className="target" style={targetStyle}>
                    {this.props.target}
                </div>



            </div>


        );
    }
}


export default Parallax;